export type { AssociatedPersonnelProps } from './associated-personnel';
export * from './associated-personnel.routes';

export { default as AssociatedPersonnel, default } from './associated-personnel';
